import { useContext } from 'react';

import { SidecarContext } from '$components/sidecar/sidecar-context';

export function useSidecarContext() {
  const sidecarContext = useContext(SidecarContext);
  return sidecarContext;
}
